import { mapGetters } from 'vuex';
import { generateComputed } from '../../../../common/functions/roles-computed-generator';
import realizaCopiaAcao from './PlanejamentoContratoFormAcoesControleCopiaDeAcao';

export default {
  props: {
    acoesRemovidas: {
      type: Array,
      default: () => [],
    },
    configuracao: {
      type: Object,
      default: () => {},
    },
    contrato: {
      type: Object,
      default: () => {},
    },
    contratoEdicao: {
      type: Object,
      default: () => {},
    },
    tiposAcaoContrato: {
      type: Array,
      default: () => [],
    },
    somenteLeitura: {
      type: Boolean,
      default: false,
    },
    alterarFinalizado: Boolean,
    copia: Boolean,
    edicao: Boolean,
    novo: Boolean,
    podeSolicitarAprovacaoContrato: Boolean,
    temFluxoContrato: Boolean,
  },
  data() {
    return {
      workflowAcaoResource: this.$api.workflowAcao(this.$resource),
      planejamentoAcaoListagemResource: this.$api.planejamentoAcaoListagem(this.$resource),
      msgRemocaoAcao: this.$t('message.remover_acao'),
      msgExecutarAnalise: this.$t('message.deseja_executar_analise_acao'),
      mensagemCancelar: this.$tc('message.deseja_cancelar_acao', 1),
      mensagemAviso: '',
      msgFluxoSemAprovador: '',
      funcCancelar: () => ({}),
      ehSolicitante: false,
      filtro: '',
      passoCliente: {},
      modalLista: false,
      idAcaoFluxo: null,
      indexAcaoSelecionada: null,
      acaoSelecionada: null,
      acaoAgrupadoraSelecionada: null,
      apuracoesAgrupadas: [],
    };
  },
  computed: {
    ...mapGetters('metadados', [
      'getProdutoMetadado',
    ]),
    ...mapGetters('roles', [
      'getUsuario',
    ]),
    ...mapGetters('usuario', [
      'usuarioLogado',
    ]),
    ...mapGetters('implantacao', [
      'indModoVarejo',
    ]),
    ...generateComputed('CONTRATO', [
      'canEdit',
    ]),
    herdarPeriodoAcao() {
      const { tipoVigencia } = this.configuracao;
      const herdarPeriodo = ['HERDAR_PERIODO_ACAO'].includes(tipoVigencia);

      return herdarPeriodo;
    },
    idContrato() {
      const { id } = this.contratoEdicao;
      return id || null;
    },
    contratoEmCadastro() {
      return this.contratoEdicao && this.contratoEdicao.passoGeral
        && ['EM_CADASTRO', 'APROVADO'].includes(this.contratoEdicao.passoGeral.status);
    },
  },
  methods: {
    permiteRemoverAcao(acao) {
      return acao && !acao.id;
    },
    permiteEditarAcao(acao) {
      return this.acaoEmCadastro(acao)
        && this.contratoEmCadastro
        && !this.isAcaoAgrupadora(acao);
    },
    defineIndicesGlobais() {
      this.acoes.forEach((acao, index) => {
        acao.index = index;
      });
    },
    permiteSolicitarAprovacao(acao) {
      return this.acaoEmCadastro(acao)
        && !this.podeSolicitarAprovacaoContrato
        && !!this.contrato.id
        && !this.isAcaoAgrupadora(acao);
    },
    permiteEditar(acao) {
      return this.acaoEmCadastro(acao)
        && !this.isAcaoAgrupadora(acao);
    },
    verificarSolicitante(idAcao) {
      this.workflowAcaoResource.solicitante({ idAcao })
        .then((response) => {
          if (response.data.usuarioHabilitado) {
            this.ehSolicitante = true;
          }
        });
    },
    podeClonar(acao) {
      return this.acaoEmCadastro(acao)
      && this.canEdit
      && !this.tipoJaUtilizado(acao)
      && !this.isAcaoAgrupadora(acao);
    },
    tipoJaUtilizado(acao) {
      const tipoAcao = this.tiposAcaoContrato
        .find((tipo) => tipo.id === acao.idAcaoTipo);
      return tipoAcao && tipoAcao.atingiuMaximo;
    },
    acaoEmCadastro(acao) {
      return (acao && acao.passoGeral
        && acao.passoGeral.status === 'EM_CADASTRO');
    },
    acaoAguardandoAprovacao(acao) {
      return (acao && acao.passoGeral
        && acao.passoGeral.status === 'AGUARDANDO_APROVACAO');
    },
    acaoAprovada(acao) {
      return (acao && acao.passoGeral
        && acao.passoGeral.status === 'APROVADO');
    },
    acaoEmAnalise(acao) {
      return (acao && acao.passoGeral
        && acao.passoGeral.status === 'EM_ANALISE' && this.isUsuarioCriacao(acao));
    },
    podeExcluir(acao) {
      return this.acaoEmCadastro(acao)
        && !acao.id
        && !this.isAcaoAgrupadora(acao);
    },
    isAcaoAgrupadora(acao) {
      return acao.passoGeral.indAcaoAgrupadora;
    },
    possuiAcaoAgrupadora(acao) {
      return !!acao.passoGeral.idAcaoAgrupadora;
    },
    isUsuarioCriacao(acao) {
      return (acao && acao.passoGeral
        && acao.passoComportamento.idUsuarioCriacao === this.usuarioLogado.id);
    },
    montarData(acao) {
      if (!this.herdarPeriodoAcao) {
        return '';
      }
      let dtaInicio = this.moment(acao.passoComportamento.dtaInicio)
        .format('DD/MM/YYYY');
      let dtaFim = this.moment(acao.passoComportamento.dtaFim)
        .format('DD/MM/YYYY');

      if (acao.passoComportamento.dtaInicio.length < 8) {
        dtaInicio = this.moment(acao.passoComportamento.dtaInicio, 'YYYY-MM').startOf('month').format('DD/MM/YYYY');
        dtaFim = this.moment(acao.passoComportamento.dtaFim, 'YYYY-MM').endOf('month').format('DD/MM/YYYY');
      }

      return this.$t('label.periodo_apuracao_datas', { dtaInicio, dtaFim });
    },
    formatarData(data) {
      return this.moment(data)
        .format('DD/MM/YYYY');
    },
    filtrar(filtro) {
      this.filtro = filtro || '';
    },
    copiaAcao(index) {
      const copia = realizaCopiaAcao(
        this.acoes[index],
        this.getProdutoMetadado,
      );
      copia.passoGeral.status = 'EM_CADASTRO';

      this.$emit(
        'PlanejamentoContratoFormAcoesControle__CopiaAcao',
        {
          acao: copia,
          callback: (retorno) => this.criaCardAcao(retorno),
        },
      );
    },
    confirmaRemoverAcao(index) {
      this.indexAcaoSelecionada = index;
      setTimeout(() => this.$refs.removerAcaoDialog.open());
    },
    removeAcao() {
      const index = this.indexAcaoSelecionada;
      const acao = this.acoes[index];
      const { id } = acao;
      if (id) {
        this.$emit('PlanejamentoContratoFormAcoesControlesItens__pushAcaoRemovida', acao);
      }

      this.acoes.splice(index, 1);
      this.acoesFormatadas.splice(index, 1);

      this.$emit(
        'PlanejamentoContratoFormAcoesControle__RemoveAcao',
        acao,
      );
    },
    confirmarExecutarAnalise(index) {
      this.indexAcaoSelecionada = index;
      setTimeout(() => this.$refs.executarAnaliseDialog.open());
    },
    executarAnalise() {
      const index = this.indexAcaoSelecionada;
      const acao = this.acoes[index];
      const dadosAcao = {
        index,
        idAcao: acao.id,
      };

      this.$emit('PlanejamentoContratoFormAcoesControle__ExecutarAnalise', dadosAcao);
    },
    preencherJustificativa(acao, justificativa) {
      acao.justificativa = justificativa;
    },
    confirmaCancelarAcao(index) {
      this.indexAcaoSelecionada = index;
      this.mensagemCancelar = this.$tc('message.deseja_cancelar_acao', 1);
      this.funcCancelar = this.cancelarAcao;
      setTimeout(() => this.$refs.cancelarAcaoDialog.open());
    },
    confirmaCancelarFluxo(index) {
      this.indexAcaoSelecionada = index;
      this.mensagemCancelar = this.$tc('message.deseja_cancelar_acao', 1);
      this.funcCancelar = this.cancelarAcaoFluxo;
      setTimeout(() => this.$refs.cancelarAcaoDialog.open());
    },
    confirmaCancelarAcaoAgrupadaAprovada(acao) {
      this.acaoSelecionada = acao;
      this.indexAcaoSelecionada = acao.index;
      this.mensagemCancelar = this.$tc('message.deseja_cancelar_acao', 1);
      this.funcCancelar = this.cancelarAcaoAgrupadaAprovada;
      setTimeout(() => this.$refs.cancelarAcaoAprovadaDialog.open(acao));
    },
    cancelarAcao(justificativa) {
      const index = this.indexAcaoSelecionada;
      const acao = this.acoes[index];
      const dadosAcao = {
        justificativa,
        index,
        usuarioCancelamento: this.getUsuario,
        idAcao: acao.id,
      };

      this.$emit('PlanejamentoContratoFormAcoesControle__CancelarAcao', dadosAcao);
    },
    cancelarAcaoFluxo(justificativa) {
      const index = this.indexAcaoSelecionada;
      const acao = this.acoes[index];
      const param = {
        observacao: justificativa,
        idAcao: acao.id,
      };
      if (acao.passoGeral && acao.passoGeral.temFluxo) {
        this.cancelarAcaoComFluxo(param);
      } else {
        this.cancelarSemFluxo(param);
      }
    },
    cancelarSemFluxo(param) {
      this.workflowAcaoResource.cancelarSemFluxo(param, param)
        .then(() => {
          this.$toast(this.$t('message.fluxo_cancelado'));
          const dadosAcao = {
            justificativa,
            index,
            usuarioCancelamento: this.getUsuario,
            idAcao: acao.id,
          };
          (this.$refs[`acaoFluxo${index}`][0] || this.$refs[`acaoFluxo${index}`]).preencherJustificativa(justificativa);
          this.preencherJustificativa(this.acoes[index], justificativa);
          this.$emit('PlanejamentoContratoFormAcoesControle__CancelarFluxo', dadosAcao);
        })
        .catch((err) => {
          this.$toast(err.data.error);
        });
    },
    cancelarAcaoComFluxo(param) {
      this.workflowAcaoResource.cancelar(param, param)
        .then(() => {
          this.$toast(this.$t('message.fluxo_cancelado'));
          const dadosAcao = {
            justificativa,
            index,
            usuarioCancelamento: this.getUsuario,
            idAcao: acao.id,
          };
          (this.$refs[`acaoFluxo${index}`][0] || this.$refs[`acaoFluxo${index}`]).preencherJustificativa(justificativa);
          this.preencherJustificativa(this.acoes[index], justificativa);
          this.$emit('PlanejamentoContratoFormAcoesControle__CancelarFluxo', dadosAcao);
        })
        .catch((err) => {
          this.$toast(err.data.error);
        });
    },
    cancelarAcaoAgrupadaAprovada(justificativa) {
      const index = this.indexAcaoSelecionada;
      const acao = this.acoes[index];
      const param = {
        observacao: justificativa,
        idAcao: acao.id,
      };
      this.workflowAcaoResource.cancelarAcaoAgrupadaAprovada(param, param)
        .then(() => {
          this.$toast(this.$t('message.fluxo_cancelado'));
          const dadosAcao = {
            justificativa,
            index,
            usuarioCancelamento: this.getUsuario,
            idAcao: acao.id,
          };
          (this.$refs[`acaoFluxo${index}`][0] || this.$refs[`acaoFluxo${index}`]).preencherJustificativa(justificativa);
          this.preencherJustificativa(this.acoes[index], justificativa);
          this.$emit('PlanejamentoContratoFormAcoesControle__CancelarAcaoAgrupadaAprovada', dadosAcao);
        })
        .catch((err) => {
          this.$toast(err.data.error);
        });
    },
    editaVisualizaAcao(acao, index) {
      this.$emit(
        'PlanejamentoContratoFormAcoesControle__EditaAcao',
        {
          acao,
          index,
          callback: (retorno) => this.atualizaArrayAcoes(retorno, index),
        },
      );
    },
    criaCardAcao(retorno) {
      const { acao, acaoFormatada } = retorno;

      acao.passoGeral.status = 'EM_CADASTRO';
      acao.passoGeral.temFluxo = false;
      acao.index = this.acoes.length;
      this.acoes.push(acao);

      if (!acao.id) {
        this.registraNovaAcaoFormatada(acaoFormatada);
      }
      setTimeout(() => this.$forceUpdate());
    },
    registraNovaAcaoFormatada(acaoFormatada) {
      const lastIndexOf = this.acoes.length - 1;
      this.acoesFormatadas[lastIndexOf] = acaoFormatada;
    },
    atualizaArrayAcoes(retorno, index) {
      const { acao, acaoFormatada } = retorno;

      this.acoes[index] = acao;
      this.acoesFormatadas[index] = acaoFormatada;
    },
    podeCancelar(acao) {
      return this.acaoEmCadastro(acao)
        && acao.id
        && this.canEdit
        && this.usuarioLogado.tipo === 'FUNCIONARIO'
        && !this.isAcaoAgrupadora(acao);
    },
    podeCancelarFluxo(acao) {
      return this.acaoAguardandoAprovacao(acao)
        && this.canEdit
        && this.usuarioLogado.tipo === 'FUNCIONARIO'
        && !this.temFluxoContrato
        && !this.isAcaoAgrupadora(acao);
    },
    podeCancelarAcaoAgrupadaAprovada(acao) {
      return this.acaoAprovada(acao)
        && this.canEdit
        && this.usuarioLogado.tipo === 'FUNCIONARIO'
        && !this.temFluxoContrato
        && !this.isAcaoAgrupadora(acao)
        && acao.passoGeral.temApuracaoPreviaMesmoPeriodo
        && !acao.passoGeral.temApuracaoPendente
        && !acao.passoGeral.indPeriodoFinalizado;
    },
    solicitarAprovacao(acao) {
      if (!acao.passoGeral.idAcaoAgrupadora) {
        this.executaSolicitarAprovacao(acao.index);
      } else {
        this.acaoSelecionada = acao;
        this.$refs.modalApuracoesAgrupadas.validarAcaoAgrupadoraEApuracoes(acao);
      }
    },
    exibirErroConflitoAcaoAgrupadora(nomeAcao) {
      this.mensagemAviso = this.$t('errors.contrato.solicitar_aprovacao_acao_data_conflito_acao_agrupadora',
        { nomeAcaoAgrupadora: nomeAcao });
      this.$refs.mensagensAvisoDialog.open();
    },
    executaSolicitarAprovacao(index = null) {
      if (!index) {
        index = this.acaoSelecionada.index;
      }
      const acao = this.acoes[index];
      if (!acao.id) {
        this.mensagemAviso = this.$t('message.salvar_contrato_antes_solicitar_aprovacao');
        this.$refs.mensagensAvisoDialog.open();
        return;
      }
      const resource = this.indModoVarejo
        ? this.workflowAcaoResource.buscaPassosFornecedor
        : this.workflowAcaoResource.buscaPassosClientes;

      this.indexAcaoSelecionada = index;
      const dadosAcao = {
        idAcao: acao.id,
      };

      this.idAcaoFluxo = acao.id;

      resource(dadosAcao)
        .then((response) => {
          const passosCliente = response.data;
          if (passosCliente.length === 0) {
            this.iniciaFluxo();
          } else if (passosCliente.length > 1) {
            const msg = this.indModoVarejo ? this.$t('errors.multiplos_passos_fornecedor')
              : this.$t('errors.multiplos_passos_cliente');
            this.$toast(msg);
          } else if (!passosCliente[0].usuarios.length) {
            this.msgFluxoSemAprovador = this.indModoVarejo
              ? this.$t('message.nao_tem_fornecedor_aprovador')
              : this.$t('message.nao_tem_cliente_aprovador');
            setTimeout(() => this.$refs.fluxoSemUsuarioClienteDialog.open());
          } else {
            // Implementado suporte para apenas 1 passo cliente/fornecedor
            const [passoCli] = passosCliente;
            this.passoCliente = passoCli;
            this.$refs.modalUsuarioCliente.open();
          }
        }).catch((err) => {
          this.$toast(this.$t(`errors.fluxo.${err.data.error}`));
        });
    },
    selecionaAprovadorPassoClienteFornecedor(idPasso, idUsuario) {
      const idAcao = this.idAcaoFluxo;
      const params = {
        idAcao,
        idPasso,
        idUsuario,
      };
      const resource = this.indModoVarejo
        ? this.workflowAcaoResource.associaUsuarioFornecedorAprovador
        : this.workflowAcaoResource.associaUsuarioClienteAprovador;
      resource(params, params)
        .then(() => this.iniciaFluxo())
        .catch((err) => this.$error(this, err));
    },
    iniciaFluxo() {
      const idAcao = this.idAcaoFluxo;
      this.workflowAcaoResource.iniciaFluxo({ idAcao }, { idAcao })
        .then(() => {
          this.recarregarDados(idAcao, this.indexAcaoSelecionada);
          this.$toast(this.$t('message.solicitacao_aprovacao'));
        })
        .catch((err) => {
          this.$error(this, err);
        });
    },
    recarregarDados(idAcao, index) {
      this.planejamentoAcaoListagemResource.buscarStatusAtualizado({ idAcao })
        .then((res) => {
          const dadosAtualizados = res.data;
          dadosAtualizados.index = index;
          if (dadosAtualizados.statusAcao === 'AGUARDANDO_APROVACAO') {
            (this.$refs[`acaoFluxo${index}`][0] || this.$refs[`acaoFluxo${index}`]).recarregarAprovador(dadosAtualizados.statusAcao);
          }
          if (dadosAtualizados.statusAcao === 'EM_ANALISE') {
            (this.$refs[`acaoFluxo${index}`][0] || this.$refs[`acaoFluxo${index}`]).buscarJustificativa(idAcao);
          }
          this.$emit('PlanejamentoContratoFormAcoesControle__atualizaDadosFluxoAcao', dadosAtualizados);
        })
        .catch((err) => {
          this.$toast(err.data.error);
        });
    },
  },
};
